<ion-header>
  <ion-toolbar>
    <ion-title>Text Record History</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal('close')">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
  
<ion-content class="no-hover-page" [fullscreen]="true" >
  
  <ng-container>
      <ion-grid>
        <!-- Table Header Row -->
        <ion-row class="table-header">
          <ion-col size="1"><strong>Index</strong></ion-col>
          <!-- <ion-col size="3"><strong>Text</strong></ion-col> -->
          <ion-col size="4"><strong>Audio</strong></ion-col>
          <ion-col size="1"><strong>User</strong></ion-col>
          <ion-col size="1"><strong>Usable</strong></ion-col>
          <ion-col size="2"><strong>IsForInterpretationOnly</strong></ion-col>
          <ion-col size="2"><strong>Date</strong></ion-col>
          <ion-col size="1"><strong>Actions</strong></ion-col>
        </ion-row>
      
        <!-- Data Rows -->
        <ion-row *ngFor="let item of historyData; let i = index" class="table-row">
          <ion-col size="1">{{ i + 1 }}</ion-col>
      
          <!-- <ion-col size="3">
            <p>{{ item.Text }}</p>
          </ion-col> -->

          <ion-col size="4">
            <div>
              <p>{{ item.Text }}</p>
              <audio controls preload="none">
                <source [src]="item.AudioPath" type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
            </div>
          </ion-col>

          <ion-col size="1">
            <p>{{ item.Username }}</p>
          </ion-col>
          <!-- <ion-col size="1">
            <p>{{ item.Usable }}</p>
          </ion-col> -->
          <ion-col size="1">
            <ion-toggle [(ngModel)]="item.Usable" (ionChange)="onUsableChange($event, item)"></ion-toggle>
            <!-- <ion-toggle [(ngModel)]="item.Usable"></ion-toggle> -->
          </ion-col>
          <!-- <ion-col size="2">
            <p>{{ item.IsForInterpretation }}</p>
          </ion-col> -->
          <ion-col size="2">
            <ion-toggle [(ngModel)]="item.IsForInterpretation" (ionChange)="onIsForInterpretationOnlyChange($event, item)"></ion-toggle>
            <!-- <ion-toggle [(ngModel)]="item.IsForInterpretation"></ion-toggle> -->
          </ion-col>
          <ion-col size="2">
            <p>{{formatDate(item.Datecreted)}}</p>
          </ion-col>
      
          <ion-col size="1">
            <div class="tooltip-wrapper">
              <ion-button class="zoom-icon-button" fill="clear" color="primary" (click)="deleteText(item)">
                <ion-icon slot="icon-only" name="trash-outline" ></ion-icon>
              </ion-button>
              <span class="custom-tooltip">Delete Audio</span>
            </div>
          </ion-col>
        </ion-row>
      
        <!-- Empty State -->
        <ion-row *ngIf="historyData.length === 0">
          <ion-col>
            <p>No history found.</p>
          </ion-col>
        </ion-row>
      </ion-grid>
      
      

  </ng-container>
  
</ion-content>
    

  
